export const stripHTMLTags = (str: string) => {
  return str.replace(/<\/?[^>]+(>|$)/g, '').trim()
}

// If you can use CSS truncation, in case you can't there is this
export const truncateString = (str: string, maxLength: number) => {
  if (!str || str.length <= maxLength) return str
  return str.slice(0, maxLength) + '...'
}

export const arrayToString = (arr: string[]) => {
  return arr.join(', ').replace(/, ([^,]*)$/, ' and $1')
}

export const titleize = (s: string) =>
  s.replace(/(?:^|\s)\S/g, a => a.toUpperCase())

export const capitalizeFirstLetter = (s: string) =>
  s.replace(/./, c => c.toUpperCase())

export const sanitizePrismicParam = (param: string) => {
  return param.replace(/['"]/g, '\\$&')
}
